(function () {
  const sectionId = document.currentScript?.dataset.sectionId;
  if (!sectionId) return;

  function initOcLuxurySliderProgress() {
    const section = document.getElementById(
      'SunglassesProduct-' + sectionId
    );

    if (!section) return;

    const pagination = section.querySelector('.swiper-pagination');

    if (!pagination) return;

    function updateLuxurySlider() {
      const text = pagination.textContent.trim();

      const match = text.match(
        /(\d+)\s*\/\s*(\d+)/
      );

      if (!match) return;

      const current = parseInt(match[1], 10);
      const total = parseInt(match[2], 10);

      if (!current || !total) return;

      const progress =
        (current / total) * 100;

      pagination.style.setProperty(
        '--oc-slider-progress',
        progress + '%'
      );
    }

    updateLuxurySlider();

    const observer =
      new MutationObserver(
        updateLuxurySlider
      );

    observer.observe(pagination, {
      childList: true,
      characterData: true,
      subtree: true
    });

    setTimeout(
      updateLuxurySlider,
      500
    );

    setTimeout(
      updateLuxurySlider,
      1200
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initOcLuxurySliderProgress,
      { once: true }
    );
  } else {
    initOcLuxurySliderProgress();
  }
})();